var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: _vm.titulo, width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.dadosVtn
            ? _c("div", [
                !_vm.isEstadoAP
                  ? _c(
                      "div",
                      [
                        _c("app-dados-calculo-vtn", {
                          attrs: {
                            dadosVtn: _vm.dadosVtn,
                            tipoProcesso: _vm.tipoProcesso,
                            resumo: true,
                            visualizar: true
                          }
                        }),
                        _c("app-resumo-parcelas-vtn", {
                          attrs: {
                            formaPagamento: _vm.dadosVtn.formaPagamento,
                            tipoProcesso: _vm.tipoProcesso
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("app-dados-calculo-vtn-AP", {
                          attrs: { dadosVtn: _vm.dadosVtn }
                        })
                      ],
                      1
                    )
              ])
            : _vm._e(),
          _vm.exibirTituloOld
            ? _c(
                "div",
                [
                  _vm.bytes &&
                  _vm.isProcesso &&
                  _vm.arrayBytes &&
                  _vm.arrayBytes.length
                    ? _c("app-pdf-viewer-old", { attrs: { bytes: _vm.bytes } })
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.bytes &&
                  _vm.isProcesso &&
                  _vm.arrayBytes &&
                  _vm.arrayBytes.length
                    ? _c("app-pdf-slider", {
                        attrs: {
                          documentosBytes: _vm.arrayBytes,
                          documentos: _vm.despachos
                        },
                        on: { changePdfDownload: _vm.changePdfDownload }
                      })
                    : _vm._e(),
                  _vm.bytes &&
                  (!_vm.arrayBytes || !_vm.arrayBytes.length) &&
                  !_vm.isImagem
                    ? _c("app-pdf-viewer", { attrs: { bytes: _vm.bytes } })
                    : _vm._e()
                ],
                1
              ),
          _vm.bytes &&
          (!_vm.arrayBytes || !_vm.arrayBytes.length) &&
          _vm.isImagem &&
          _vm.visualizarDocumentosPDF
            ? _c("app-image-viewer", { attrs: { bytes: _vm.bytes } })
            : _vm._e()
        ],
        1
      ),
      !_vm.dadosVtn && !_vm.imprimir
        ? _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "flex" },
              [
                !_vm.isImagem
                  ? _c("el-button", { on: { click: _vm.downloadPdf } }, [
                      _c("i", { staticClass: "fal fa-file-pdf" }),
                      _c("span", [_vm._v("  Exportar PDF")])
                    ])
                  : _vm._e(),
                _vm.isImagem
                  ? _c("el-button", { on: { click: _vm.downloadPdf } }, [
                      _c("i", { staticClass: "fal fa-file-pdf" }),
                      _c("span", [_vm._v("  Exportar Imagem")])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.imprimir
        ? _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c("el-button", { on: { click: _vm.imprimirPDF } }, [
                  _c("i", { staticClass: "fal fa-print" }),
                  _c("span", [_vm._v("  Imprimir")])
                ])
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bfff22c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bfff22c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppModalVisualizaPdf.vue
// module id = null
// module chunks = 